import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { LocaleProvider } from "./context/LocaleContext";
import Home from "./pages/Home";
import About from "./pages/About";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import AnnualReports from "./pages/AnnualReports";
import Projects from "./pages/Projects";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <Router>
      <LocaleProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/documents/annual-reports" element={<AnnualReports />} />
          <Route path="/documents/projects" element={<Projects />} />
        </Routes>
      </LocaleProvider>
    </Router>
  );
};

export default AppRoutes;
